// extracted by css-extract-rspack-plugin
export default {"bui-Skeleton":"dQdXlDCvsLk1w8Z3"};